import { IPlainObject, ServerErrorBaseModel } from '../models';
import { is } from './is';
import { AxiosError } from 'axios';
import { pathOr } from 'rambda';

export function getAxiosErrorMessage(
  error:
    | AxiosError<ServerErrorBaseModel>
    | AxiosError<IPlainObject, IPlainObject>,
): string {
  const data = pathOr<ServerErrorBaseModel>(
    {} as ServerErrorBaseModel,
    ['response', 'data'],
    error,
  );

  const message = data.message || 'Unprocessable Entity';

  return is.string(message) ? message : JSON.stringify(message);
}
